<script setup lang="ts">

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import {
  faArrowUpRight,
  faLink,
  faListCheck,
  faPlus,
  faRotateRight,
  faSync,
  faTrash,
} from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useCustomerActions } from '../model/customer-actions.hook'

defineOptions({
  name: 'CustomerActions',
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  isProcessing,
  isVisible,
  canManage,
  canAddKid,
  canDelete,
  isTasksVisible,
  toggle,
  actOnBehalf,
  addKid,
  createTask,
  viewTasks,
  pushToCrm,
  pullFromCrm,
  askDelete,
  sendReload,
  pushToRespond,
} = useCustomerActions()
</script>

<template>
  <div
    v-if="isVisible"
    ref="containerRef"
    class="customer-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      title="Customer actions"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="customer-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-if="canManage"
          text="Act on behalf"
          color="blue"
          :prepend-icon="faLink"
          @click="actOnBehalf"
        />
        <AppDropdownItem
          v-if="canAddKid"
          text="Add kid"
          color="blue"
          :prepend-icon="faPlus"
          @click="addKid"
        />
        <AppDropdownItem
          v-if="isTasksVisible"
          text="Create task"
          color="blue"
          :prepend-icon="faListCheck"
          @click="createTask"
        />
        <AppDropdownItem
          v-if="isTasksVisible"
          text="View all customer tasks"
          color="blue"
          :prepend-icon="faArrowUpRight"
          @click="viewTasks"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Sync to Zoho"
          color="blue"
          :prepend-icon="faSync"
          :disabled="isProcessing"
          @click="pushToCrm"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Sync from Zoho"
          color="red"
          :prepend-icon="faSync"
          :disabled="isProcessing"
          @click="pullFromCrm"
        />
        <AppDropdownItem
          v-if="canDelete"
          text="Delete customer"
          color="red"
          :prepend-icon="faTrash"
          @click="askDelete"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Force page reload"
          color="blue"
          :prepend-icon="faRotateRight"
          :disabled="isProcessing"
          @click="sendReload"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Push to Respond"
          color="blue"
          :prepend-icon="faWhatsapp"
          :disabled="isProcessing"
          @click="pushToRespond"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerActions.scss" />
